import type { FC, ReactNode } from 'react'

import { openCookieSettings } from '@/lib/consent'
import { cn } from '@/lib/utils'

interface CookieSettingsButtonProps {
    className?: string
    label?: string
}

export const CookieSettingsButton: FC<CookieSettingsButtonProps> = ({
    className,
    label = 'Cookie settings'
}): ReactNode => {
    return (
        <button
            type='button'
            onClick={openCookieSettings}
            className={cn('cursor-pointer transition-colors hover:text-primary', className)}
        >
            {label}
        </button>
    )
}
